"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const devicesService = {
  getDeviceProtocolMarkers: function () {
    return api.get("/Devices/ProtocolMarkers", WithToken.headersToken({}, configuration.cookieName));
  },
  getDevices: function (serchTerm) {
    return api.get("/Devices", WithToken.headersToken({ params: { imei: serchTerm } }, configuration.cookieName));
  },
  getDevice: function (id) {
    return api.get(`/Devices/${id}`, WithToken.headersToken({ params: {} }, configuration.cookieName));
  },
  updateDevices: function (id, options) {
    return api.put(`/Devices/${id}`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  createConnectedSensor: function (options) {
    return api.post(
      `/ConnectedSensors/?deviceId=${options.deviceId}&sensorId=${options.sensorId}`,
      options.deviceInPut,
      WithToken.headersToken({}, configuration.cookieName)
    );
  },
  deleteConnectedSensor: function (options) {
    return api.delete(`/ConnectedSensors`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  createCalibration: function (options) {
    return api.post(
      `/ConnectedSensors/${options.id}/Calibrations`,
      options.calibration,
      WithToken.headersToken({}, configuration.cookieName)
    );
  },
  deleteCalibration: function (options) {
    return api.delete(
      `/ConnectedSensors/${options.id}/Calibrations`,
      WithToken.headersToken({ params: { calibrationId: options.calibrationId } }, configuration.cookieName)
    );
  },
  replaceDevices: function (options) {
    return api.put(
      `/Devices/${options.id}/Replace`,
      options,
      WithToken.headersToken({ params: { deviceReplaceId: options.deviceReplaceId } }, configuration.cookieName)
    );
  },
  unitByDevice: function (id) {
    return api.get(`/Devices/${id}/Unit`, WithToken.headersToken({}, configuration.cookieName));
  },
  devicePatterns: function () {
    return api.get("/Devices/PatternDevices", WithToken.headersToken({}, configuration.cookieName));
  },
  createDevice: function (options) {
    return api.post(`/Devices`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  uploadCalibrations: function (id, options) {
    return api.post(
      `/ConnectedSensors/${id}/Calibrations/Upload`,
      options,
      WithToken.headersToken(
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
        configuration.cookieName
      )
    );
  },
  downloadCalibrations: function (id) {
    return api.get(
      `/ConnectedSensors/${id}/Calibrations/Download`,
      WithToken.headersToken({ responseType: "blob" }, configuration.cookieName)
    );
  },
  createCommand(id, options) {
    return api.post(`/Devices/${id}/Commands`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteCommand(id) {
    return api.delete(`/Devices/${id}/Commands`, WithToken.headersToken({}, configuration.cookieName));
  },
};

export default devicesService;
